import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";
import { apiRequest } from "../services/apiService";

// Komponenty Material-UI dla nowoczesnego wyglądu
import {
  Box,
  Typography,
  Paper,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Container } from "react-bootstrap";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

export default function Menu() {
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("getpossibilities", "GET");
        if (Array.isArray(response)) {
          setOptions(response);
        } else {
          setOptions([]);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, []);

  // Grupowanie opcji pobranych z API
  const groupedOptions = options.reduce((acc, item) => {
    if (!acc[item.groupname]) {
      acc[item.groupname] = [];
    }
    acc[item.groupname].push(item);
    return acc;
  }, {});

  return (
    <div
      style={{
        backgroundColor: "#fafafa",
        minHeight: "100vh",
        paddingBottom: "40px",
      }}
    >
      <VN userData={userData} />

      <Container style={{ marginTop: "40px", maxWidth: "1100px" }}>
        {/* Główny nagłówek */}
        <Box sx={{ mb: 5, textAlign: { xs: "center", sm: "left" } }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{ fontWeight: 700, color: "#1a237e", mb: 1 }}
          >
            Usługi w ramach opieki
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Przeglądaj pełen zakres certyfikowanych czynności, które mogą
            realizować nasze opiekunki.
          </Typography>
        </Box>

        {/* Nowy, szablonowy układ oparty na dwóch niezależnych kolumnach CSS */}
        <Box
          sx={{
            display: "column",
            columnCount: { xs: 1, md: 2 }, // 1 kolumna na telefonach, 2 na desktopie
            columnGap: "32px", // Odstęp między kolumnami
          }}
        >
          {Object.entries(groupedOptions).map(([groupName, items]) => (
            <Paper
              key={groupName}
              elevation={0}
              sx={{
                padding: "24px",
                borderRadius: "16px",
                border: "1px solid #f0f0f0",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.03)",
                marginBottom: "32px", // Margines na dole karty, by nie sklejały się w pionie
                breakInside: "avoid", // Zapobiega rozrywaniu jednej karty pomiędzy kolumny
                transition: "box-shadow 0.3s",
                "&:hover": {
                  boxShadow: "0px 6px 25px rgba(0, 0, 0, 0.07)",
                },
              }}
            >
              {/* Tytuł grupy */}
              <Typography
                variant="h6"
                component="h2"
                sx={{
                  marginBottom: 2,
                  fontWeight: 600,
                  color: "#2c3e50",
                  borderBottom: "2px solid #e8f5e9",
                  pb: 1,
                }}
              >
                {groupName}
              </Typography>

              {/* Lista elementów */}
              <List disablePadding>
                {items.map((item) => (
                  <ListItem
                    key={item.id}
                    disablePadding
                    sx={{
                      padding: "8px 12px",
                      borderRadius: "8px",
                      marginBottom: "4px",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        backgroundColor: "#e8f5e9",
                        transform: "translateX(4px)",
                      },
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: "36px" }}>
                      <TaskAltIcon sx={{ color: "#2e7d32", fontSize: 22 }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={item.activity}
                      primaryTypographyProps={{
                        variant: "body1",
                        sx: { color: "#455a64", fontWeight: 500 },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Paper>
          ))}
        </Box>
      </Container>
    </div>
  );
}
